import { render, staticRenderFns } from "./UiLoading.vue?vue&type=template&id=613a36c0&scoped=true&"
import script from "./UiLoading.vue?vue&type=script&lang=ts&"
export * from "./UiLoading.vue?vue&type=script&lang=ts&"
import style0 from "./UiLoading.vue?vue&type=style&index=0&id=613a36c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613a36c0",
  null
  
)

export default component.exports